import { render, staticRenderFns } from "./MaskeRegel.vue?vue&type=template&id=8284f834"
import script from "./MaskeRegel.vue?vue&type=script&lang=js"
export * from "./MaskeRegel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports